/** Material UI Packages. */
import { Link } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';

/** Material UI Icons. */
import BorderColorIcon from '@mui/icons-material/BorderColor';

/** Define trade partner datagrid fields. */
export const TradePartnerDef = (handleEditClick) => [
    {
        field: 'id',
        headerName: 'ID',
        align: 'center',
        headerAlign: 'center',
        hide: true,
        flex: 0.1,
    },
    {
        field: 'partner_type',
        headerName: 'Type',
        align: 'center',
        headerAlign: 'center',
        flex: 0.7,
    },
    {
        field: 'code',
        headerName: 'Code',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
    },
    {
        field: 'iata_firms',
        headerName: 'IATA(Firms)',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
    },
    {
        field: 'fullname',
        headerName: 'Full Name',
        align: 'center',
        headerAlign: 'center',
        flex: 1.5,
    },
    {
        field: 'name',
        headerName: 'Name',
        align: 'center',
        headerAlign: 'center',
        flex: 0.7,
    },
    {
        field: 'address_one',
        headerName: 'Address',
        align: 'center',
        headerAlign: 'center',
        flex: 3,
    },
    {
        field: 'contact',
        headerName: 'Contact Person',
        align: 'center',
        headerAlign: 'center',
        flex: 0.6,
    },
    {
        field: 'phone',
        headerName: 'Phone',
        align: 'center',
        headerAlign: 'center',
        flex: 0.5,
    },
    {
        field: 'website',
        headerName: 'Website',
        align: 'center',
        headerAlign: 'center',
        flex: 0.5,
        renderCell: (params) => {
            return (
                <Link href={params.value ? `${params.value}` : '#'} target="_blank" rel="noopener">
                    {params.value ? 'Go to Website' : ''}
                </Link>
            );
        },
    },
    {
        field: 'status',
        type: 'boolean',
        headerName: 'Active',
        align: 'center',
        headerAlign: 'center',
        flex: 0.28,
    },
    {
        field: 'action',
        type: 'actions',
        headerName: 'Edit',
        align: 'center',
        headerAlign: 'center',
        flex: 0.28,
        getActions: ({ row }) => {
            return [
                <GridActionsCellItem
                    sx={{
                        bgcolor: '#003a52',
                        color: 'white',
                        '&:hover': { color: '#003a52' },
                        p: '5px',
                    }}
                    icon={<BorderColorIcon sx={{ fontSize: 13 }} />}
                    label="edit"
                    onClick={() => handleEditClick(row)}
                    color="secondary"
                />,
            ];
        },
    },
];
